const stage = 'test'

module.exports = require(`./${stage}`)
